import * as t from 'io-ts';
import { OktmoCode, OktmoCodeType } from './oktmoCode';

export const OktmoMinType = t.interface({
    id: t.union([t.string, t.null, t.undefined]),
    name: t.union([t.string, t.null, t.undefined]),
    fullName: t.union([t.string, t.null, t.undefined]),
    code: t.union([OktmoCodeType, t.null, t.undefined]),
});

export interface OktmoMinDTO extends t.TypeOf<typeof OktmoMinType> {}

class OktmoMin {
    id: string | null;
    name: string | null;
    code: OktmoCode | null;
    fullName: string | null;

    constructor(params: OktmoMinDTO) {
        this.id = params.id ?? null;
        this.code = !!params.code
            ? new OktmoCode(params.code)
            : null;
        this.name = params.name ?? null;
        this.fullName = params.fullName ?? null;
    }
}

export { OktmoMin };
